import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./common-pop-up.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./common-pop-up.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SubscriberComponent } from "../subscriber/subscriber.component";
import { SharedConstants } from "../../constants/shared-constants";
export let CommonPopUpComponent = class CommonPopUpComponent extends SubscriberComponent {
    activeModal;
    title = "";
    contentMessage = "";
    data;
    updateBtnPlaceholder = SharedConstants.YES_LABEL;
    cancelBtnPlaceholder = SharedConstants.NO_LABEL;
    constructor(activeModal) {
        super();
        this.activeModal = activeModal;
    }
    onBtnOkClick() {
        this.activeModal.close(this.data);
    }
    onBtnCancel() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        contentMessage: [{ type: Input }],
        data: [{ type: Input }],
        updateBtnPlaceholder: [{ type: Input }],
        cancelBtnPlaceholder: [{ type: Input }]
    };
};
CommonPopUpComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: "lib-pop-up.component",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CommonPopUpComponent);
